// Подписи и числа дашборда собственника.

const MN = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
const MNF = ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'];
export const WD = ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'];

/** «2026-10» → «окт 26». */
export const ml = (m: string) => `${MN[+m.slice(5) - 1]} ${m.slice(2, 4)}`;
/** «2026-10» → «октябрь 2026». */
export const mlf = (m: string) => `${MNF[+m.slice(5) - 1]} ${m.slice(0, 4)}`;

const nf = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 });
export const num = (v: number | null | undefined) => (v == null || !isFinite(v) ? '—' : nf.format(Math.round(v)));

/** Крупно: «6,85 млн ₽», «245 тыс ₽», «950 ₽». */
export function rub(v: number | null | undefined) {
  if (v == null || !isFinite(v)) return '—';
  const a = Math.abs(v);
  const s = v < 0 ? '−' : '';
  if (a >= 1e6) return `${s}${(a / 1e6).toFixed(2).replace('.', ',')} млн ₽`;
  if (a >= 1e4) return `${s}${nf.format(Math.round(a / 1e3))} тыс ₽`;
  return `${s}${nf.format(Math.round(a))} ₽`;
}
/** Точно: «−1 234 567 ₽». */
export const rubx = (v: number) => `${v < 0 ? '−' : ''}${nf.format(Math.abs(Math.round(v)))} ₽`;
export const pct = (v: number | null | undefined, d = 1) =>
  v == null || !isFinite(v) ? '—' : `${(v * 100).toFixed(d).replace('.', ',')}%`;
/** Подписи осей: «6,9 млн», «245 тыс». */
export function ax(v: number) {
  const a = Math.abs(v);
  const s = v < 0 ? '−' : '';
  if (a >= 1e6) return `${s}${(a / 1e6).toFixed(a >= 1e7 ? 0 : 1).replace('.', ',')} млн`;
  if (a >= 1e3) return `${s}${Math.round(a / 1e3)} тыс`;
  return `${s}${Math.round(a)}`;
}
export const sum = (a: number[]) => a.reduce((s, x) => s + (+x || 0), 0);
export const ddmmyyyy = (d: string) => d.split('-').reverse().join('.');

/** Месяцы «ГГГГ-ММ» от a до b включительно. */
export function monthsBetween(a: string, b: string) {
  const out: string[] = [];
  let [y, m] = a.split('-').map(Number);
  const [y2, m2] = b.split('-').map(Number);
  while (y < y2 || (y === y2 && m <= m2)) {
    out.push(`${y}-${String(m).padStart(2, '0')}`);
    m += 1;
    if (m > 12) {
      m = 1;
      y += 1;
    }
  }
  return out;
}
export const lastDay = (m: string) => {
  const [y, mo] = m.split('-').map(Number);
  return `${m}-${String(new Date(y, mo, 0).getDate()).padStart(2, '0')}`;
};
